import styled from 'styled-components'

export const FlexAlignCenter = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled.h4`
  font-size: 16px;
  font-weight: 700;
`

export const Desc = styled.p`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 24px;
`
